import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { lt, useLocalizeText, FormInputField, FormTextareaField } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { ReservationLinkResult } from '@mews-commander/data-access';
import { CreatePaymentPlanFormValues } from '../schema';
import { useGetAmountsForPaymentPlanSuspense } from '../hooks';
import { CreatePaymentPlanFormField } from '../types';
import { PaymentAmountInputField } from '../../../common/PaymentAmountInputField';
import { FirstPaymentDetails } from '../FirstPaymentDetails';
import { getDefaultAmount } from '../utils';
import { CreatePaymentPlanDialogFormPaymentRequestMessageField } from './CreatePaymentPlanDialogFormPaymentRequestMessageField';

export const FirstPaymentFormFields = ({ reservation }: { reservation: ReservationLinkResult }) => {
    const localizeText = useLocalizeText();
    const { setValue } = useFormContext<CreatePaymentPlanFormValues>();
    const { monthlyAmounts } = useGetAmountsForPaymentPlanSuspense(reservation);

    const firstReservationMonthTotalAmount = getDefaultAmount(monthlyAmounts[0].amount);

    useEffect(() => {
        setValue(CreatePaymentPlanFormField.Amount, firstReservationMonthTotalAmount.value);
    }, [firstReservationMonthTotalAmount, setValue]);

    return (
        <Stack vertical spacing="300">
            <FirstPaymentDetails reservation={reservation} />
            <PaymentAmountInputField
                name={CreatePaymentPlanFormField.Amount}
                label={lt('CreatePaymentPlanFormPaymentRequestAmountLabel')}
                readOnly
                required={false}
                currencyCode={firstReservationMonthTotalAmount.currency}
                defaultValue={firstReservationMonthTotalAmount.value}
            />
            <FormInputField
                name={CreatePaymentPlanFormField.Reason}
                label={lt('CreatePaymentPlanFormPaymentRequestReasonLabel')}
                defaultValue={localizeText({ textKey: TextKey.PaymentRequestReasonRecurringPayment })}
                readOnly
            />
            <CreatePaymentPlanDialogFormPaymentRequestMessageField reservation={reservation} />
            <FormTextareaField
                name={CreatePaymentPlanFormField.Note}
                label={lt('CreatePaymentPlanFormPaymentRequestNoteLabel')}
                rows={1}
            />
        </Stack>
    );
};
